import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT, ROUTE } from '../data/content';
export function SystemSection() {
  return <section aria-labelledby="sistema" className="border-y-4 border-solar bg-navy" data-id="element-183" data-mp="3bi3pusft2166">
      <div className="mx-auto max-w-page px-3 py-5 sm:px-6 sm:py-7" data-id="element-184" data-mp="36klhp49m3pz8">
        <Reveal className="text-center" data-id="element-185" data-mp="31kgwj0xre72o">
          <p className="text-[0.66rem] font-black uppercase tracking-[0.24em] text-solar sm:text-xs" data-id="element-186" data-mp="31lim0afiuw3x">
            ☀️ El sistema completo 6 en 1
          </p>
          <h2 id="sistema" className="mt-0.5 font-display text-xl uppercase leading-[1.04] text-white sm:text-3xl" data-id="element-187" data-mp="2ss5iyfnque44">
            {PRODUCT}
          </h2>
        </Reveal>

        <Reveal delay={0.04} className="mx-auto mt-2 flex max-w-4xl flex-wrap items-center justify-center gap-1" data-id="element-188" data-mp="2ity1zwtgfw24">
          {ROUTE.map((step, i) => <React.Fragment key={step} data-id="element-189" data-mp="13z7z3dw4eus1" data-mpi={i}>
              <span className="rounded-md bg-azure px-2.5 py-1 text-[0.66rem] font-black uppercase tracking-wide text-white sm:px-3 sm:text-[0.76rem]" data-id="element-190" data-mp="13y6mh4zgi087">
                {step}
              </span>
              {i < ROUTE.length - 1 && <ChevronRightIcon size={13} aria-hidden="true" className="text-solar" strokeWidth={3} data-id="element-191" data-mp="tyxl3r29hjbt" />}
            </React.Fragment>)}
        </Reveal>

        <Reveal delay={0.08} className="mt-3" data-id="element-192" data-mp="1rnr3vjfyopfd">
          <a href={OFFER_ANCHOR} className="block" data-id="element-193" data-mp="1rmg37shtbxsh">
            <img src={PACK_IMAGE} alt={`Contenido incluido en ${PRODUCT}`} className="mx-auto w-full max-w-lg rounded-lg border-2 border-solar" data-id="element-194" data-mp="1cqqcxi5lgyhy" />
          </a>
        </Reveal>
      </div>
    </section>;
}